<template>
    <ScrollView
        ref="scrollView"
        class="scroll-view-wrapper"
        style="overflow-y:hidden;background:#fff"
        :probeType="1"
        :pullup="pullup"
        :pulldown="pullup"
        :bounce="false"
    >
        <div class="slip_banner">
            <div
                :class="['banner',isErrorFn()]"
                :style="{width:winWidth+'px'}"
            >
                <div class="stack-wrapper">
                    <!-- commod 商品区域 -->
                    <ul class="stack">
                        <li
                            class="stack-item"
                            v-for="(item, index) in pages"
                            :key="item.skuId"
                            :style="[transformIndex(index),transform(index)]"
                            @touchmove="touchmove"
                            @touchstart="touchstart"
                            @touchend="touchend"
                            @transitionend="onTransitionEnd(index)"
                            @click="lookInfo(item.skuId)"
                        >
                            <KPL
                                :url="item.jumpUrl"
                                :sku="item.skuId"
                                :clstag="'jr|keycount|8530052_1227_discover_sku|'+item.rule"
                                :eventId="'MInterestFree_BottomNavFind'"
                                :eventParam="item.rule"
                            >
                                <div class="tip">
                                    <span>{{item.installment}}个月免息</span>
                                </div>
                                <div class="commod_img">
                                    <img
                                        v-lazy="item.imageUrl"
                                        alt=""
                                    />
                                </div>
                                <div class="info_text">
                                    <div class="money">
                                        <span>每月</span>
                                        <span class="ui-red">￥</span>
                                        <span class="ui-red">{{item.installmentPrice}}</span>
                                        <!-- <span>×{{item.installment}}期</span> -->
                                        <!-- <span>￥{{item.goodsPrice}}</span> -->
                                    </div>
                                    <div class="commod_name">
                                        <span
                                            v-if="false"
                                            class="ui-gold"
                                        >专享</span>
                                        <span
                                            v-if="item.isSelfService"
                                            class="ui-selfRed"
                                        >自营</span>{{item.goodsName}}
                                    </div>
                                </div>
                            </KPL>
                        </li>
                    </ul>
                    <div
                        v-show="firstPopUpTip.isShow"
                        :class="['addShoppingOrLike',firstPopUpTip.isShow?'addShoppingOrLikeAnim':'']"
                        @transitionend="firstDelSL"
                        @click="firstAddSL"
                    >
                        <div class="item_img">
                            <img v-lazy="firstPopUpTip.skuImg">
                        </div>
                        <div class="info">
                            <div>
                                <span>已添加</span>
                                <span>至 {{firstPopUpTip.text}}</span>
                            </div>
                        </div>
                        <div class="go_commod">
                            <div>
                                去看看
                            </div>
                        </div>
                    </div>
                    <div
                        class="btns_area"
                        v-if="!isError"
                    >
                        <ul>
                            <li
                                @click="throttle('del')"
                                :clstag="'jr|keycount|8530052_discover_left_icon|'+temporaryData.currentPage+'_'+jskuId"
                            >
                                <img
                                    @transitionend="homePage1animEnd('del')"
                                    :class="[isAddAnimGeuss.del?'active_opacity':'']"
                                    :style="btnDelOpacity()"
                                    src="https://img30.360buyimg.com/cms/jfs/t22861/92/2578968613/3483/ae5cf842/5b868fc7N8195a2f4.png"
                                    alt=""
                                >
                                <img
                                    src="https://img10.360buyimg.com/cms/jfs/t27592/173/129930005/3927/7004ae7e/5b868fc7N0ccbd1f5.png"
                                    lazy="loaded"
                                    alt=""
                                >
                            </li>
                            <li
                                class="check_shopping"
                                @click="check_shopping()"
                                :clstag="'jr|keycount|8530052_discover_cart|check'"
                            >
                                <div>
                                    查看购物车
                                </div>
                            </li>
                            <!-- <li @click="addAnim('like')" @transitionend="homePage1animEnd('like')" :class="isAddAnimGeuss.like?'active_scale':''"><img src="../assets/images/home_collection_cion.png" alt=""></li> -->
                            <li
                                @click="throttle('shopping')"
                                :clstag="'jr|keycount|8530052_discover_right_icon|'+temporaryData.currentPage+'_'+jskuId"
                            >
                                <img
                                    @transitionend="homePage1animEnd('shopping')"
                                    :class="isAddAnimGeuss.shopping?'active_opacity':''"
                                    :style="btnShoppingOpacity()"
                                    src="https://img14.360buyimg.com/cms/jfs/t24844/252/1297117592/3935/7de946c5/5b90dd91N65c21025.png"
                                    lazy="loaded"
                                    alt=""
                                >
                                <img
                                    src="https://img10.360buyimg.com/cms/jfs/t27328/106/393447248/4530/be2699bc/5b90dd91N25af9f39.png"
                                    lazy="loaded"
                                    alt=""
                                >
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="slip_dir">
          <img src="../assets/images/slip_dir.png" alt="">
        </div> -->
                <Error
                    ref="errorInstance"
                    v-show="isError"
                ></Error>
            </div>
            <!-- <Navigation ref="nav" :isShow="true" /> -->
        </div>
        <Guide
            ref="guideInstance"
            v-if="isShowGuide"
            @onFinish="onFinishGuide"
        />
    </ScrollView>
</template>
<script>
import KPL from '@/buscomponents/KPL';
// import Navigation from '@/buscomponents/Navigation';
import Guide from '@/buscomponents/Guide';
import Error from '@/components/ServiceError/ServiceError';
import ScrollView from '@/components/ScrollView';
import detectPrefixes from '../util/detectPrefixes';
import addCart from '../util/addCartToKPL.js';
import request from '@/util/request';
import { openByKpl } from '@/util/kpl';
import { shareInit, HideShare } from '@/util/share';
import { setJDJRNativeHeaderColor } from '@/util/jdjrNative';
import { genLinkBySSR } from '@/util/common';
import { messages } from '@/config';

import '@/scss/discover.scss';
export default {
    name: 'discover',
    components: {
        KPL,
        // Navigation,
        ScrollView,
        Guide,
        Error
    },

    watch: {},
    computed: {
        // 划出面积比例
        offsetRatio() {
            let width = this.$el.offsetWidth;
            let height = this.$el.offsetHeight;
            let offsetWidth = width - Math.abs(this.temporaryData.poswidth);
            let offsetHeight = height - Math.abs(this.temporaryData.posheight);
            /* eslint-disable */
            let ratio = 1 - (offsetWidth * offsetHeight) / (width * height) || 0;
            return ratio > 1 ? 1 : ratio;
        },
        // 划出宽度比例
        offsetWidthRatio() {
            let width = this.$el.offsetWidth;
            let offsetWidth = width - Math.abs(this.temporaryData.poswidth);
            let ratio = 1 - offsetWidth / width || 0;
            return ratio;
        }
    },
    data() {
        return {
            jskuId: '',
            winHeight: document.body.offsetHeight,
            winWidth: document.body.offsetWidth,
            pullup: false,
            pages: [],
            stackArr: [],
            throttleTime: {
                preTime: 0
            },
            basicdata: {
                start: {},
                end: {},
                direction: 0,
                onceDir: false
            },
            temporaryData: {
                prefixes: detectPrefixes(),
                offsetY: '',
                poswidth: 0,
                posheight: 0,
                lastPosWidth: '',
                lastPosHeight: '',
                lastZindex: '',
                rotate: 0,
                lastRotate: 0,
                visible: 3,
                tracking: false,
                animation: false,
                currentPage: 0,
                opacity: 1,
                lastOpacity: 0,
                swipe: false,
                zIndex: 10
            },
            emitData: {
                index: 0,
                skuId: '',
                type: '',
                isRest: false,
                skuImg: ''
            },
            firstPopUpTip: {
                type: 'shopping',
                skuImg: '',
                isFirstShopping: window.localStorage.isFirstShopping,
                isFirstLike: window.localStorage.isFirstLike,
                isShow: false
            },
            stackData: {
                index: 0
            },
            // 添加喜欢/购物车/删除按钮动画
            isAddAnimGeuss: {
                del: false,
                like: false,
                shopping: false
            },
            isLastId: {
                skuId: window.localStorage.skuId == undefined || window.localStorage.skuId == null ? '0' : window.localStorage.skuId,
                preTimeDay: window.localStorage.preTimeDay ? parseInt(window.localStorage.preTimeDay) : 0
            },
            btnDleOpacity: {
                del: '',
                shopping: ''
            },
            isShowGuide: false,
            isError: false,
            reqServerCount: 0
        };
    },
    created() {
        try {
            HideShare({ title: '发现', moreItem: true, hideTools: false, textColor: 1 });

            const defaultOption = {
                shareURL: genLinkBySSR('activity'),
                shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
                shareTitle: messages.shareTitle,
                shareDesc: messages.shareDesc,
                shareChannels: ['0', '1', '3']
            };
            shareInit(defaultOption);
        } catch (error) {
            console.log(error);
        }

        this.isShowGuide = !localStorage.guided ? true : false;
        this.compareTime();
        this.firstRecommendHomePage();

        // 加了e.preventDefault()，chrome console 中会报错：Unable to preventDefault inside passive event listener invocation
        // 可以不用禁用touchmove，页面也不会上下移动
        // document.addEventListener('touchmove', e => {
        //   e.preventDefault();
        // });
    },
    mounted() {},
    methods: {
        // 查看当前时间
        isErrorFn() {
            return this.isError ? 'banner_error' : '';
        },
        addAnim(pran) {
            switch (pran) {
                case 'del':
                    this.isAddAnimGeuss.del = true;
                    break;
                case 'shopping':
                    this.isAddAnimGeuss.shopping = true;
                    // 添加到购物车动画
                    if (!this.firstPopUpTip.isFirstShopping) {
                        this.firstPopUpTip['text'] = '购物车';
                        this.firstPopUpTip.type = 'shopping';
                        this.firstPopUpTip.skuImg = this.pages[this.emitData.index].imageUrl;
                        this.firstPopUpTip.isShow = true;
                        window.localStorage.isFirstShopping = true;
                        this.firstPopUpTip.isFirstShopping = true;
                        setTimeout(() => {
                            this.firstPopUpTip.isShow = false;
                        }, 3000);
                    }
                    break;
                default:
                    break;
            }
            if (pran === 'like') {
                this.isAddAnimGeuss.like = true;
                this.reqLikeCommod();
                // 添加到收藏动画
                if (!this.firstPopUpTip.isFirstLike) {
                    this.firstPopUpTip['text'] = '收藏夹';
                    this.firstPopUpTip.type = 'like';
                    this.firstPopUpTip.skuImg = this.pages[this.emitData.index].imageUrl;
                    this.firstPopUpTip.isShow = true;
                    window.localStorage.isFirstLike = true;
                    this.firstPopUpTip.isFirstLike = true;
                    setTimeout(() => {
                        this.firstPopUpTip.isShow = false;
                    }, 1000);
                }
            }
        },
        homePage1animEnd(pran) {
            switch (pran) {
                case 'del':
                    this.isAddAnimGeuss.del = false;
                    break;
                case 'like':
                    this.isAddAnimGeuss.like = false;
                    break;
                case 'shopping':
                    this.isAddAnimGeuss.shopping = false;
                    break;
            }
        },
        compareTime() {
            let curDay = parseInt(new Date().getTime() / 1000 / 60 / 60 / 24);
            if (this.isLastId.preTimeDay == 0) {
                // 第一次进入页面
                this.isLastId.skuId = '0';
                window.localStorage.preTimeDay = parseInt(curDay);
            } else if (curDay > this.isLastId.preTimeDay) {
                this.isLastId.skuId = '0';
                window.localStorage.preTimeDay = parseInt(curDay);
            }
        },
        throttle(type) {
            let time = new Date().getTime();
            if (this.throttleTime.prev == 0) {
                // 第一次
                this.throttleTime.preTime = time;
            } else if (time - this.throttleTime.preTime >= 500) {
                // 第二次
                if (type == 'del') {
                    this.prev();
                    this.addAnim('del');
                    console.log('del');
                } else if (type == 'shopping') {
                    this.next();
                    // this.addAnim('shopping');
                }
                this.throttleTime.preTime = time;
            } else if (time - this.throttleTime.preTime < 500) {
                return false;
            }
        },
        // 删除动画
        firstDelSL() {
            setTimeout(() => {
                this.firstPopUpTip.isShow = false;
            }, 3000);
        },
        // 首次添加
        firstAddSL() {
            if (this.firstPopUpTip.type == 'like') {
                // 收藏夹
                this.$router.push({ path: '/favorite' });
            } else if (this.firstPopUpTip.type == 'shopping') {
                // 购物车
                let open = openByKpl;
                if(this.$openByKpl){
                    open=this.$openByKpl;
                }
                open({ url: 'https://p.m.jd.com/cart/cart.action' });
            }
        },
        check_shopping() {
            let open = openByKpl;
            if(this.$openByKpl){
                open=this.$openByKpl;
            }
            open({ url: 'https://p.m.jd.com/cart/cart.action' });
        },
        touchstart(e) {
            if (this.temporaryData.tracking) {
                return;
            }
            // 是否为touch
            if (e.type === 'touchstart') {
                if (e.touches.length > 1) {
                    this.temporaryData.tracking = false;
                    return;
                } else {
                    // 记录起始位置
                    this.basicdata.start.t = new Date().getTime();
                    this.basicdata.start.x = e.targetTouches[0].clientX;
                    this.basicdata.start.y = e.targetTouches[0].clientY;
                    this.basicdata.end.x = e.targetTouches[0].clientX;
                    this.basicdata.end.y = e.targetTouches[0].clientY;
                    // offsetY在touch事件中没有，只能自己计算
                    this.temporaryData.offsetY = e.targetTouches[0].pageY - this.$el.offsetParent.offsetTop;
                }
            }
            this.temporaryData.tracking = true;
            this.temporaryData.animation = false;
        },

        touchmove(e) {
            // 记录滑动位置
            if (this.temporaryData.tracking && !this.temporaryData.animation) {
                // 只支持移动端
                this.basicdata.end.x = e.targetTouches[0].clientX;
                this.basicdata.end.y = e.targetTouches[0].clientY;
                // 2018.0.31暂时取消以下代码
                // --------------------------------
                // 判断方向，只有左右才会执行滑动，否则会是系统自带的scroll，如果是左右滑动，添加revenDefalt
                // 公式touchstartX-touchmoveX>5,设定为5个人觉得比较滑动比较流畅
                // if (this.basicdata.onceDir == false) {
                //   if (this.basicdata.direction == 0 && (Math.abs(this.basicdata.start.x - this.basicdata.end.x) > 5 || Math.abs(this.basicdata.start.y - this.basicdata.end.y) > 5)) {
                //     this.basicdata.direction = this.GetSlideDirection(this.basicdata.start.x, this.basicdata.start.y, this.basicdata.end.x, this.basicdata.end.y);
                //   }
                // }
                // if (this.basicdata.direction == 3 || this.basicdata.direction == 4) {
                //   // 左右
                // } else {
                //   // 上下
                //   return false;
                // }
                // --------------------------------
                e.preventDefault();
                this.temporaryData.poswidth = this.basicdata.end.x - this.basicdata.start.x;
                this.temporaryData.posheight = this.basicdata.end.y - this.basicdata.start.y;

                let rotateDirection = this.rotateDirection();
                let angleRatio = this.angleRatio();
                this.temporaryData.rotate = rotateDirection * this.offsetWidthRatio * 15 * angleRatio;
                this.btnOpacity();
            }
        },
        touchend() {
            this.temporaryData.tracking = false;
            this.temporaryData.animation = true;
            this.basicdata.direction = 0;
            this.basicdata.onceDir == false;
            // 滑动结束，触发判断
            // 判断划出面积是否大于0.4
            if (this.offsetRatio >= 0.4) {
                // 计算划出后最终位置
                let ratio = Math.abs(this.temporaryData.posheight / this.temporaryData.poswidth);
                this.temporaryData.poswidth = this.temporaryData.poswidth >= 0 ? this.temporaryData.poswidth + 200 : this.temporaryData.poswidth - 200;
                this.temporaryData.posheight = this.temporaryData.posheight >= 0 ? Math.abs(this.temporaryData.poswidth * ratio) : -Math.abs(this.temporaryData.poswidth * ratio);
                this.temporaryData.opacity = 0;
                this.temporaryData.swipe = true;
                this.nextTick();
                // 不满足条件则滑入
            } else {
                this.temporaryData.poswidth = 0;
                this.temporaryData.posheight = 0;
                this.temporaryData.swipe = false;
                this.temporaryData.rotate = 0;
            }
        },
        nextTick(type) {
            let skuId = '';
            let skuImg = '';
            this.btnDleOpacity.del = '0';
            this.btnDleOpacity.shopping = '0';
            this.temporaryData.lastPosWidth = this.temporaryData.poswidth;
            this.temporaryData.lastPosHeight = this.temporaryData.posheight;
            this.temporaryData.lastRotate = this.temporaryData.rotate;
            this.temporaryData.lastZindex = 20;
            this.temporaryData.currentPage = this.temporaryData.currentPage === this.pages.length - 1 ? 0 : this.temporaryData.currentPage + 1;

            if (this.temporaryData.lastPosWidth > 0 || type == 'add') {
                this.emitData.type = 'shopping';

                this.emitData.index = this.temporaryData.currentPage - 1;

                if (this.emitData.index < 0) {
                    this.emitData.index = this.pages.length - 1;

                    if (this.pages[this.emitData.index]) {
                        skuId = this.pages[this.emitData.index].skuId;
                        skuImg = this.pages[this.emitData.index].imageUrl;
                    }

                    this.emitData['skuId'] = skuId;
                    this.emitData['skuImg'] = skuImg;
                } else {
                    if (this.pages[this.emitData.index]) {
                        skuId = this.pages[this.emitData.index].skuId;
                        skuImg = this.pages[this.emitData.index].imageUrl;
                    }

                    this.emitData['skuId'] = skuId;
                    this.emitData['skuImg'] = skuImg;
                }
                setTimeout(() => {
                    this.likeGoods(skuId);
                }, 50);
                this.addAnim('shopping');
                addCart({
                    sku: skuId,
                    addSuccess: (isSueecss, res) => {
                        // if (isSueecss) {
                        //   this.$alert.show({
                        //     content: res.msg
                        //   });
                        // } else {
                        //   this.$alert.show({
                        //     content: res.msg
                        //   });
                        // }
                    },
                    addFail: () => {
                        this.$alert.show({
                            content: '抱歉，添加购物车失败'
                        });
                    }
                });
                //   this.$emit('stackCurIndex', this.emitData);
            } else if (this.temporaryData.lastPosWidth < 0 || type == 'del') {
                this.emitData.type = 'del';

                this.emitData.index = this.temporaryData.currentPage - 1;

                if (this.emitData.index < 0) {
                    this.emitData.index = this.pages.length - 1;

                    skuId = this.pages[this.emitData.index].skuId;
                    skuImg = this.pages[this.emitData.index].imageUrl;

                    this.emitData['skuId'] = skuId;
                    this.emitData['skuImg'] = skuImg;
                } else {
                    skuId = this.pages[this.emitData.index].skuId;
                    skuImg = this.pages[this.emitData.index].imageUrl;

                    this.emitData['skuId'] = skuId;
                    this.emitData['skuImg'] = skuImg;
                }
                this.hateGoods(skuId);
            }
            this.$nextTick(() => {
                this.temporaryData.poswidth = 0;
                this.temporaryData.posheight = 0;
                this.temporaryData.opacity = 1;
                this.temporaryData.rotate = 0;
            });
            this.jskuId = skuId;
        },
        onTransitionEnd(index) {
            let lastPage = this.temporaryData.currentPage === 0 ? this.pages.length - 1 : this.temporaryData.currentPage - 1;
            // dom发生变化正在执行的动画滑动序列已经变为上一层
            if (this.temporaryData.swipe && index === lastPage) {
                this.secondRecommendHomePage(lastPage);
                this.temporaryData.animation = true;
                this.temporaryData.lastPosWidth = 0;
                this.temporaryData.lastPosHeight = 0;
                this.temporaryData.lastOpacity = 0;
                this.temporaryData.lastRotate = 0;
                this.temporaryData.swipe = false;
                this.temporaryData.lastZindex = -1;
            }
        },
        // 非首页样式切换
        transform(index) {
            let currentPage = this.temporaryData.currentPage;
            let length = this.pages.length;
            let lastPage = currentPage === 0 ? this.pages.length - 1 : currentPage - 1;
            let style = {};
            let visible = this.temporaryData.visible;
            if (index === this.temporaryData.currentPage) {
                return;
            }
            if (this.inStack(index, currentPage)) {
                let perIndex = index - currentPage > 0 ? index - currentPage : index - currentPage + length;
                style['opacity'] = (this.temporaryData.visible - perIndex) * 0.2;
                style['transform'] = 'translate3D(0,0,' + -1 * 60 * (perIndex - this.offsetRatio) + 'px' + ')';
                style['zIndex'] = visible - perIndex;
                if (!this.temporaryData.tracking) {
                    style[this.temporaryData.prefixes.transition + 'TimingFunction'] = 'ease';
                    style[this.temporaryData.prefixes.transition + 'Duration'] = 300 + 'ms';
                }
            } else if (index === lastPage) {
                style['transform'] =
                    'translate3D(' + this.temporaryData.lastPosWidth + 'px' + ',' + this.temporaryData.lastPosHeight + 'px' + ',0px) ' + 'rotate(' + this.temporaryData.lastRotate + 'deg)';
                style['opacity'] = this.temporaryData.lastOpacity;
                style['zIndex'] = this.temporaryData.lastZindex;
                style[this.temporaryData.prefixes.transition + 'TimingFunction'] = 'ease';
                style[this.temporaryData.prefixes.transition + 'Duration'] = 300 + 'ms';
            } else {
                style['zIndex'] = '-1';
                style['transform'] = 'translate3D(0,0,' + -1 * visible * 60 + 'px' + ')';
            }
            return style;
        },
        // 首页样式切换
        transformIndex(index) {
            if (index === this.temporaryData.currentPage) {
                let style = {};
                style['transform'] = 'translate3D(' + this.temporaryData.poswidth + 'px' + ',' + this.temporaryData.posheight + 'px' + ',0px) ' + 'rotate(' + this.temporaryData.rotate + 'deg)';
                style['opacity'] = this.temporaryData.opacity;
                style['zIndex'] = 10;
                if (this.temporaryData.animation) {
                    style[this.temporaryData.prefixes.transition + 'TimingFunction'] = 'ease';
                    style[this.temporaryData.prefixes.transition + 'Duration'] = (this.temporaryData.animation ? 300 : 0) + 'ms';
                }
                return style;
            }
            // 按钮运动
        },
        // 控制按钮
        btnOpacity() {
            if (this.temporaryData.poswidth > 0) {
                // shopping
                this.btnDleOpacity.shopping = this.temporaryData.poswidth * 0.005;
            } else if (this.temporaryData.poswidth < 0) {
                // del
                this.btnDleOpacity.del = Math.abs(this.temporaryData.poswidth) * 0.005;
            }
        },
        btnDelOpacity() {
            let style = {};
            style['opacity'] = this.btnDleOpacity.del;
            return style;
        },
        btnShoppingOpacity() {
            let style = {};
            style['opacity'] = this.btnDleOpacity.shopping;
            return style;
        },
        prev() {
            this.temporaryData.tracking = false;
            this.temporaryData.animation = true;
            let width = this.$el.offsetWidth;
            this.temporaryData.poswidth = -width;
            this.temporaryData.posheight = 0;
            this.temporaryData.opacity = 0;
            this.temporaryData.rotate = '-3';
            this.temporaryData.swipe = true;
            this.nextTick('del');
        },
        next() {
            this.temporaryData.tracking = false;
            this.temporaryData.animation = true;
            let width = this.$el.offsetWidth;
            this.temporaryData.poswidth = width;
            this.temporaryData.posheight = 0;
            this.temporaryData.opacity = 0;
            this.temporaryData.rotate = '3';
            this.temporaryData.swipe = true;
            this.nextTick('add');
        },
        rotateDirection() {
            if (this.temporaryData.poswidth <= 0) {
                return -1;
            } else {
                return 1;
            }
        },
        angleRatio() {
            let height = this.$el.offsetHeight;
            let offsetY = this.temporaryData.offsetY;
            /* eslint-disable */
            let ratio = -1 * ((2 * offsetY) / height - 1);
            return ratio || 0;
        },
        inStack(index, currentPage) {
            let stack = [];
            let visible = this.temporaryData.visible;
            let length = this.pages.length;
            for (let i = 0; i < visible; i++) {
                if (currentPage + i < length) {
                    stack.push(currentPage + i);
                } else {
                    stack.push(currentPage + i - length);
                }
            }
            return stack.indexOf(index) >= 0;
        },

        // 计算滑动位置
        GetSlideDirection(startX, startY, moveX, moveY) {
            var dy = moveY - startY;
            var dx = moveX - startX;
            var result = 0;
            //如果滑动距离太短
            if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
                return result;
            }
            var angle = this.GetSlideAngle(dx, dy);
            if (angle >= -45 && angle < 45) {
                result = 4;
            } else if (angle >= 45 && angle < 135) {
                result = 1;
            } else if (angle >= -135 && angle < -45) {
                result = 2;
            } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
                result = 3;
            }
            return result;
        },
        GetSlideAngle(dx, dy) {
            /* eslint-disable */
            return (Math.atan2(dy, dx) * 180) / Math.PI;
        },
        // 首次加载
        firstRecommendHomePage(opts = {}) {
            const _self = this;
            this.reqRecommendHomePage({
                success: recommendGoodsList => {
                    if (recommendGoodsList.length < 5 && _self.stackArr.length < 5) {
                        _self.stackArr = _self.stackArr.concat(recommendGoodsList);
                        _self.firstRecommendHomePage(opts);
                        return;
                    } else {
                        _self.stackArr = _self.stackArr.concat(recommendGoodsList);
                        _self.pages = _self.stackArr.splice(0, 5);
                        //   console.log('firstRecommendHomePage', this.reqCommodArr);
                        opts.success && opts.success();
                    }
                }
            });
        },
        // 第二次加载
        secondRecommendHomePage(index) {
            const _self = this;
            this.getOneRecommendHomePage({
                success: newOneItem => {
                    if (_self.pages[index] && newOneItem) {
                        _self.pages[index] = newOneItem;
                    }
                }
            });
        },
        // 获得一个头图数
        getOneRecommendHomePage(opts = {}) {
            if (this.stackArr.length < 10) {
                var isCallback = false;
                if (this.stackArr.length > 0) {
                    opts.success(this.stackArr.shift());
                    isCallback = true;
                }

                this.reqRecommendHomePage({
                    success: recommendGoodsList => {
                        this.stackArr = this.stackArr.concat(recommendGoodsList);
                        if (!isCallback) {
                            opts.success(this.stackArr.shift());
                        }
                    }
                });
            } else {
                opts.success(this.stackArr.shift());
            }
        },
        // 发ajax reqRecommendHomePage
        reqRecommendHomePage(opts) {
            if (this.hasLoadingRecommendHomePage) {
                return;
            }
            if (this.reqServerCount > 5) {
                this.isError = true;
                return;
            }
            this.hasLoadingRecommendHomePage = true;
            request.recommendHomePage({
                // 参数
                data: { lastId: this.isLastId.skuId },
                // 成功,请求回来的lastID是在极限情况下，没有数据才会使用，否则不会使用
                success: ({ recommendGoodsList, isEnd, lastId }) => {
                    this.hasLoadingRecommendHomePage = false;
                    console.log('返回数据条数:', recommendGoodsList.length);

                    let _lastIdTemp = '';

                    if (isEnd) {
                        _lastIdTemp = '0';
                    } else {
                        if (recommendGoodsList && recommendGoodsList.length) {
                            _lastIdTemp = recommendGoodsList[recommendGoodsList.length - 1].skuId;
                        }
                        if (!_lastIdTemp && lastId) {
                            _lastIdTemp = lastId;
                        }
                    }

                    this.isLastId.skuId = _lastIdTemp;
                    window.localStorage.skuId = _lastIdTemp;

                    if (recommendGoodsList.length === 0) {
                        this.reqServerCount++;
                    } else {
                        this.reqServerCount = 0;
                    }

                    opts.success(recommendGoodsList);
                },
                // 接口错误，在error方法后调用
                error: () => {
                    this.hasLoadingRecommendHomePage = false;
                }
            });
        },
        onFinishGuide() {
            try {
                if (!localStorage.guided) {
                    localStorage.guided = false;
                    localStorage.isShowGuide = false;
                }
            } catch (error) {
                console.log(error);
            }
            this.isShowGuide = false;
        },
        likeGoods(skuId) {
            this.behavior(0, skuId);
        },
        hateGoods(skuId) {
            this.behavior(1, skuId);
        },
        lookInfo(skuId) {
            this.behavior(2, skuId);
        },
        behavior(type, skuId) {
            request.userBehaviorCollect({
                data: {
                    skuId: skuId,
                    behaviorType: type
                },
                success: rs => {
                    console.log(rs);
                },
                error: () => {}
            });
        }
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>

<style lang="scss">
.bar-scroll {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
}
.ui-red {
    color: #f13a4d !important;
}
</style>
